import { useSSRContext } from 'vue'
import type { SSRContext } from '@/types/ssr/SSRContext'

export function getRequestHostname() {
  if (import.meta.env.SSR) {
    const ctx = <SSRContext>useSSRContext()
    return ctx.hostname
  }

  return new URL(window.location.href).host
}
